// directives/glow.ts
import { DirectiveBinding } from 'vue';

export const primaryGlow = {
  mounted(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    if (binding.value) {
      el.style.boxShadow = '0px 0px 45px rgba(244, 83, 132, 0.3)';
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        el.style.boxShadow = '0px 0px 45px rgba(244, 83, 132, 0.3)';
      } else {
        el.style.boxShadow = 'none';
      }
    }
  }
};
